import type { ReactNode } from 'react'
import { Heart } from 'lucide-react'

type ResultCardProps = {
  name: string
  selected: boolean
  onSelect: () => void
  liked: boolean
  onToggleLike: () => void
  href: string
  ctaLabel: string
  /** The detail lines under the name — whatever this kind of result wants to show. */
  children: ReactNode
}

/**
 * A single result in a MapListIndex rail: name, caller-supplied detail lines,
 * a favourite toggle and a link out. Pairs with MapListIndex but isn't required
 * by it — a list with different chrome can render whatever it likes.
 */
export default function ResultCard({
  name,
  selected,
  onSelect,
  liked,
  onToggleLike,
  href,
  ctaLabel,
  children,
}: ResultCardProps) {
  return (
    <div
      onClick={onSelect}
      className={`flex cursor-pointer gap-3 rounded-2xl border bg-panel p-3.5 shadow-sm transition ${selected ? 'border-accent9 ring-2 ring-accent9' : 'border-gray5 hover:border-gray7'}`}
    >
      <div className="flex min-w-0 flex-1 flex-col justify-between gap-2">
        <p className="truncate text-[15px] font-bold leading-tight">{name}</p>
        {children}
      </div>
      <div className="flex flex-col items-end justify-between gap-3">
        <button
          type="button"
          aria-label={liked ? 'Remove from favorites' : 'Add to favorites'}
          onClick={(e) => { e.stopPropagation(); onToggleLike() }}
          className={`cursor-pointer transition ${liked ? 'text-accent9' : 'text-gray8 hover:text-gray11'}`}
        >
          <Heart className="h-5 w-5" fill={liked ? 'currentColor' : 'none'} />
        </button>
        <a
          href={href}
          onClick={(e) => e.stopPropagation()}
          className="rounded-full border-2 border-accent9 px-4 py-1 text-sm font-bold text-accent11 transition hover:bg-accent9 hover:text-accent-contrast"
        >
          {ctaLabel}
        </a>
      </div>
    </div>
  )
}
